const en = {
  accountProtection: 'Account protection',
  accountReviewRequired: 'Your account needs a review. Your draft has not been published and is still here. You can request a review in Settings → Account.',
  accountRateLimited: 'Please pause before trying again. Your draft is still here.',
  accountRateLimitedUntil: 'Please try again in about {{minutes}} min. Your draft is still here.',
  protectionState_limited: 'Please pause before trying again. This activity limit is temporary.',
  protectionState_quarantined: 'Your account activity is under review. New drafts are private and do not affect public statistics.',
  protectionState_suspended: 'Account actions are restricted. You can request a review.',
  accountAppealPending: 'Your review request has been received.',
  accountAppealPrompt: 'Tell us why this restriction may be a mistake.',
  accountAppealSend: 'Request review',
  accountRecoveryInfo: 'These drafts are private and expire after seven days. Restore text to edit and send it yourself. Check any recordings and reposts again.',
  restoreStoryDraft: 'Restore event draft', restoreCommentDraft: 'Restore comment draft',
  accountRecoveryStorageError: 'There is not enough room to restore this draft on this device. Your server copy is unchanged and remains available until its expiry date.',
  accountRecoveryExpired: 'This private draft has expired.',
};
const ru = {
  accountProtection: 'Защита аккаунта',
  accountReviewRequired: 'Аккаунту требуется проверка. Черновик не опубликован и остался в редакторе. Запросить пересмотр можно в Настройки → Аккаунт.',
  accountRateLimited: 'Подождите немного перед следующей попыткой. Черновик остался в редакторе.',
  accountRateLimitedUntil: 'Попробуйте снова примерно через {{minutes}} мин. Черновик остался в редакторе.',
  protectionState_limited: 'Подождите немного перед следующей попыткой. Ограничение активности временное.',
  protectionState_quarantined: 'Активность аккаунта проверяется. Новые черновики видны только вам и не влияют на общую статистику.',
  protectionState_suspended: 'Действия аккаунта ограничены. Вы можете запросить пересмотр.',
  accountAppealPending: 'Запрос на пересмотр получен.',
  accountAppealPrompt: 'Расскажите, почему ограничение могло быть ошибочным.',
  accountAppealSend: 'Запросить пересмотр',
  accountRecoveryInfo: 'Эти черновики видны только вам и хранятся семь дней. Восстановите текст, отредактируйте и отправьте самостоятельно. Записи и репосты нужно проверить заново.',
  restoreStoryDraft: 'Восстановить заголовок', restoreCommentDraft: 'Восстановить комментарий',
  accountRecoveryStorageError: 'На этом устройстве недостаточно места для восстановления черновика. Серверная копия не изменена и доступна до указанной даты истечения.',
  accountRecoveryExpired: 'Срок хранения этого приватного черновика истёк.',
};
const zh = {
  accountProtection: '账号保护',
  accountReviewRequired: '您的账号需要审核。草稿尚未发布，仍保留在编辑器中。您可以前往设置 → 账号申请复核。',
  accountRateLimited: '请稍候再试。草稿仍保留在编辑器中。',
  accountRateLimitedUntil: '请约 {{minutes}} 分钟后再试。草稿仍保留在编辑器中。',
  protectionState_limited: '请稍候再试。此活动限制是临时的。',
  protectionState_quarantined: '账号活动正在审核。新草稿仅您可见，不计入公开统计。',
  protectionState_suspended: '账号操作受到限制。您可以申请复核。',
  accountAppealPending: '已收到您的复核申请。',
  accountAppealPrompt: '请说明此限制可能有误的原因。',
  accountAppealSend: '申请复核',
  accountRecoveryInfo: '这些草稿仅您可见，保存七天。恢复文字后请自行编辑并发送。请重新检查录音、视频和转发内容。',
  restoreStoryDraft: '恢复事件草稿', restoreCommentDraft: '恢复评论草稿',
  accountRecoveryStorageError: '此设备没有足够空间恢复草稿。服务器副本未更改，在到期前仍可使用。',
  accountRecoveryExpired: '此私人草稿已过期。',
};
const translations = { en, ru, zh };
export default translations;
